import React from 'react';
import { WarningIcon, InfoIcon } from './Icons';
import './ConfirmModal.css';

function ConfirmModal({ isOpen, title, message, confirmText = 'Patvirtinti', cancelText = 'Atšaukti', onConfirm, onCancel, type = 'warning' }) {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'danger':
        return <WarningIcon />;
      case 'warning':
        return <WarningIcon />;
      case 'info':
        return <InfoIcon />;
      default:
        return <InfoIcon />;
    }
  };

  return (
    <div className="confirm-modal-overlay" onClick={onCancel}>
      <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-modal-icon">{getIcon()}</div>
        {title && <h3 className="confirm-modal-title">{title}</h3>}
        <p className="confirm-modal-message">{message}</p>
        <div className="confirm-modal-actions">
          <button
            className={`btn btn-secondary ${type === 'danger' ? 'btn-danger' : ''}`}
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button
            className={`btn btn-primary ${type === 'danger' ? 'btn-danger' : ''}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
